// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function TriangleRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "TriangleRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M7 20V4L19 12.5333L7 20Z", fill: "currentColor" }))));
});
//# sourceMappingURL=TriangleRight.js.map